import { render, staticRenderFns } from "./ModalEnableTwoFa.vue?vue&type=template&id=6be3e6a1&scoped=true"
import script from "./ModalEnableTwoFa.vue?vue&type=script&lang=js"
export * from "./ModalEnableTwoFa.vue?vue&type=script&lang=js"
import style0 from "./ModalEnableTwoFa.vue?vue&type=style&index=0&id=6be3e6a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3e6a1",
  null
  
)

export default component.exports